import EntertainmentRecommender from "./components/EntertainmentRecommender";
import AdminPanel from "./components/AdminPanel";
import ErrorBoundary from "./components/ErrorBoundary";
import { AuthProvider } from "./context/AuthContext";
import { HelmetProvider } from "react-helmet-async";
import React from "react";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookiePolicy from "./components/CookiePolicy";
import RefundPolicy from "./components/RefundPolicy";
import ContactUs from "./components/ContactUs";
import AboutUs from "./components/AboutUs";
import WhyUs from "./components/WhyUs";
import Explore from "./components/Explore";
import ConsentBanner from "./components/ConsentBanner";
import PolicyUpdateGate from "./components/PolicyUpdateGate";
import SEO, { normalizePath } from "./components/SEO";

function App() {
  // "/about/" and "/About" are treated the same as "/about".
  const path = normalizePath(window.location.pathname);

  // /history, /my-list and /liked are signed-in pages that live inside
  // EntertainmentRecommender; it reads the URL to decide which one to open.
  const renderPage = () => {
    switch (path) {
      case "/":
      case "/home":
      case "/history":
      case "/my-list":
      case "/liked":
        return <EntertainmentRecommender />;
      case "/admin":
        return <AdminPanel />;
      case "/privacy":
        return <PrivacyPolicy />;
      case "/terms":
        return <TermsOfService />;
      case "/whyus":
        return <WhyUs />;
      case "/explore":
        return <Explore />;
      case "/cookies":
        return <CookiePolicy />;
      case "/refund":
        return <RefundPolicy />;
      case "/contact":
        return <ContactUs />;
      case "/about":
        return <AboutUs />;
      default:
        return <EntertainmentRecommender />;
    }
  };

  return (
    <HelmetProvider>
      <SEO path={path} />
      <ErrorBoundary>
        <AuthProvider>
          {renderPage()}
          <PolicyUpdateGate path={path} />
        </AuthProvider>
      </ErrorBoundary>
      <ConsentBanner />
    </HelmetProvider>
  );
}

export default App;
